var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2330 2922 l0 -209 -56 29 c-155 78 -331 -1 -380 -169 -43 -146 27 -306 155 -361 80 -33 198 -15 259 41 l22 20 0 -31 0 -32 95 0 95 0 0 460 0 460 -95 0 -95 0 0 -208z m-61 -326 c42 -22 61 -58 61 -117 0 -45 -4 -55 -34 -85 -30 -30 -40 -34 -86 -34 -89 0 -139 56 -127 143 12 86 107 133 186 93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952 3088 c-61 -16 -93 -113 -56 -166 18 -26 65 -52 94 -52 34 0 78 28 95 60 24 46 19 85 -15 124 -33 37 -68 47 -118 34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3783 3085 c-88 -37 -97 -157 -13 -200 37 -19 63 -19 100 0 57 30 77 94 46 153 -24 46 -85 67 -133 47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 2650 l0 -440 100 0 100 0 0 175 0 175 140 0 140 0 0 90 0 90 -140 0 -140 0 0 85 0 85 155 0 155 0 0 90 0 90 -255 0 -255 0 0 -440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3120 2650 l0 -440 100 0 100 0 0 175 0 175 140 0 140 0 0 90 0 90 -140 0 -140 0 0 85 0 84 153 3 152 3 3 88 3 87 -256 0 -255 0 0 -440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4080 2860 l0 -100 -40 0 -40 0 0 -75 0 -75 40 0 40 0 0 -132 c1 -175 19 -226 94 -265 54 -28 226 -13 226 20 0 6 -10 41 -22 78 -20 64 -23 67 -45 58 -31 -11 -29 -12 -47 7 -13 12 -16 39 -16 125 l0 109 55 0 55 0 0 75 0 75 -55 0 -55 0 0 100 0 100 -95 0 -95 0 0 -100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490 2759 c-13 -6 -39 -21 -57 -35 l-33 -25 0 31 0 31 -92 -3 -93 -3 -3 -272 -2 -273 95 0 95 0 0 163 c0 145 2 165 20 195 40 65 119 74 165 20 25 -29 25 -33 25 -204 l0 -174 95 0 95 0 0 203 c0 190 -1 205 -22 247 -25 49 -70 84 -127 100 -45 12 -128 12 -161 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 2485 l0 -275 95 0 95 0 0 275 0 275 -95 0 -95 0 0 -275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3727 2753 c-4 -3 -7 -127 -7 -275 l0 -268 95 0 95 0 0 275 0 275 -88 0 c-49 0 -92 -3 -95 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 2520 l0 -80 170 0 170 0 0 80 0 80 -170 0 -170 0 0 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4530 2418 c-63 -43 -78 -109 -37 -169 65 -97 217 -51 217 67 0 36 -6 51 -33 80 -43 48 -97 56 -147 22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.1c78f453de28b33c97daed2978974679.svg";
export { ForwardRef as ReactComponent };